export default __webpack_public_path__ + "static/media/PawPatrol_05.84314ac2.png";